import React from "react";
import logo from "./logo.svg";
import styles from "./site-loader.module.scss";
import PropTypes from "prop-types";
import Button from "~/components/Button";
import { useAuth } from "@workos-inc/authkit-react";

function ErrorWithLogo({
  errorMessage = "Loading your information, please wait.",
  errorStatus = null,
}) {
  const { signOut } = useAuth();

  const getErrorTitle = () => {
    if (!errorStatus) return "Something went wrong";

    switch (errorStatus) {
      case 0:
        return "Connection Error";
      case 403:
        return "Access Denied";
      case 500:
        return "Server Error";
      case 502:
      case 503:
      case 504:
        return "Service Unavailable";
      case 404:
        return "Not Found";
      default:
        return `Error (${errorStatus})`;
    }
  };

  const needsRefresh = [0, 500, 502, 503, 504].includes(errorStatus);

  return (
    <div className={styles.wrapper}>
      <img src={logo} alt="HSP" />
      {errorStatus && <h3 className={styles.errorTitle}>{getErrorTitle()}</h3>}
      <p className={styles.error}>{errorMessage}</p>
      <div className="flex gap-4">
        <Button
          label="Sign Out"
          onClick={() =>
            signOut({
              returnTo: window.location.origin,
            })
          }
          variant="contained"
        />
        {needsRefresh && (
          <Button
            label="Try Again"
            onClick={() => window.location.reload()}
            variant="contained"
          />
        )}
      </div>
    </div>
  );
}

ErrorWithLogo.propTypes = {
  errorMessage: PropTypes.string,
  errorStatus: PropTypes.number,
};

export default ErrorWithLogo;
